module.exports = __webpack_public_path__ + "assets/img/xjllsc.185ce78c.png";